export const cilCursor = ["24 24","<path d='M14.218 23.25h1.735l5.295-20.045c0.020-0.072 0.031-0.154 0.031-0.239 0-0.518-0.42-0.938-0.938-0.938-0.145 0-0.282 0.033-0.404 0.091l0.006-0.002-18.443 8.657v1.734l7.751 3.1zM19.49 3.986l-4.624 17.507-4.616-7.101-6.98-2.792z'></path>"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/js/free/cil-cursor.js
// module id = null
// module chunks = 